<template>
  <div class="box">
    <v-card class="mx-auto">
      <v-sheet
        color="grey lighten-3"
        height="50"
        style="justify-content: center; display: flex; align-items: center"
        ><p class="title mb-0">Image</p></v-sheet
      >

      <v-card-text>
        <ul class="img-view">
          <li
            v-for="url in urls"
            v-bind:key="url"
            v-on:click="
              () => {
                selectImage(url);
              }
            "
          >
            <i class="lni lni-frame-expand"></i>
            <img :src="url" alt />
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["urls"],
  methods: {
    selectImage(url) {
      this.$store.commit("updateImageSelected", url);
      this.$store.commit("setDialogImageLectureClass", {
        className: "open",
        url,
      });
    },
  },
};
</script>